/**
 * Enum for XR input button.
 */
export enum XRInputButton {
  /** None */
  None = 0x0,
  /** Select */
  Select = 0x1,
  /** Select */
  Trigger = 0x1,
  /** Squeeze */
  Squeeze = 0x2,
  /** TouchPad */
  TouchPad = 0x4,
  /** A */
  AButton = 0x8,
  /** B */
  BButton = 0x10
}
